'use strict';

var createEnum = require('./createEnum');

module.exports = createEnum(['NONE', 'ICANN', 'TAXES', 'ALL']);